import { RoutePath, type RoutePaths } from "@/lib/routes"
import { DASHBOARD_ROOT_URL } from "../constants/dashboardRootUrl"

const agreementRootPath = RoutePath.create(
    `/${DASHBOARD_ROOT_URL}/comptes/:accountNumber/logements/:propertyId/contrats`
)

export const agreementRoutesPaths = {
    agreements: agreementRootPath,
    agreement: agreementRootPath.create("/:agreementId"),
    agreementAuthorization: agreementRootPath.create("/:agreementId/autorisation"),
    agreementPaymentAdjustment: agreementRootPath.create("/:agreementId/ajustement-mensualite"),
} as const satisfies RoutePaths
